export enum ZoomSessionType {
  WEBINAR = 'Webinar',
  MEETING = 'Meeting',
}

export enum ZoomSessionStatus {
  READY = 'Ready',
  DRAFT = 'Draft',
}

export interface IZoomSession {
  id: string;
  zoomIntegrationId: string;
  type: ZoomSessionType;
  status: ZoomSessionStatus;
  eventId: string;
  start: string;
  end: string;
  name: string;
  meetingId: number;
  meetingJoinUrl: string;
  meetingStartUrl: string;
  zoomSessionSetupId: string;
  createdDate: string;
  createdBy: string;
  modifiedDate: string;
  modifiedBy: string;
}

export interface IZoomIntegration {
  id: string;
  providerId: string;
  authorizationUrl: string;
  authorizationRedirectUrl: string;
  authorized: string;
  authorizedBy: string;
}

export interface IZoomSessionSetup {
  id: string;
  zoomIntegrationId: string;
  eventGroupId: string;
  type: ZoomSessionType;
  active?: boolean; // true if there are events in the future
  createdDate: string;
  createdBy: string;
  modifiedDate: string;
  modifiedBy: string;
  zoomIntegration?: IZoomIntegration;
  zoomSessions?: IZoomSession[];
  waitingRoom?: boolean;
}

export interface IZoomSessionSetupUpdate {
  zoomIntegrationId: string;
  eventGroupId: string;
  type: ZoomSessionType;
}

export interface IZoomIntegrationIssue {
  id: string;
  zoomIntegrationId: string;
  zoomSessionId: string;
  eventId: string;
  scope: 'ZoomIntegration' | 'ZoomSession';
  level: 'Info' | 'Warning' | 'Critical';
  title: string; // lokalise key
  description: string; // lokalise key
}
